import React from 'react';
import HeaderLess, { HeaderLessProps } from '@ecs/tng-common/src/components/header/HeaderLess';
import Footer from '@ecs/tng-common/src/components/footer/Footer';
import { ILayoutCommon } from '@ecs/tng-common/src/interfaces';
// styles
// eslint-disable-next-line import/no-extraneous-dependencies
import '@ecs/tng-common/src/styles/bootstrap-no-purge.scss';
import '../styles/global/bootstrap.scss';
import '../styles/global/bootstrap-less-layout.scss';

interface LayoutProps extends ILayoutCommon {
  headerLess?: HeaderLessProps;
}
class LayoutLess extends React.PureComponent<LayoutProps> {
  render() {
    return (
      <>
        <HeaderLess
          {...this.props.headerLess}
          pageType="product"
        />
        <main id="main">{this.props.children}</main>
        <Footer
          tradeMarkFootNote={this.props.tradeMarkFootNote}
          pageType="product"
        />
      </>
    );
  }
}

export default LayoutLess;
